import { useContext, useEffect, useState } from 'react';
import { HookFormContext } from 'components/cef_form/hook-form/providers/HookFormProvider';
import AlertBox from 'components/ui-components/AlertBox';
import MetaHelmet from 'helpers/MetaHelmet';
import StepTemplate from '../StepTemplate';
import CompanyTypeSelector from './CompanyTypeSelector';
import CreditRadios from './CreditRadios';
import BusinessTypeSelector from './BusinessTypeSelector';
import CompanyNumberSelector from './CompanyNumberSelector';
import SoleTraderCompany from './SoleTraderCompany';
import GovernmentBody from './GovernmentBody';

const Step2 = () => {
  const {
    companyTypes,
    businessTypeData,
    handlePrevStep,
    setCurrentStep,
    watchedFields: { companyType },
    clearErrors,
  } = useContext(HookFormContext);

  useEffect(() => {
    setCurrentStep(2);
    // Clear any postcode selector errors lingering if user has some back from Step 3
    clearErrors();
  }, []);

  // ROUTE SETUP
  const [selectedCompanyType, setSelectedCompanyType] = useState('');

  // Find corresponding item from companyType array based on company_type value
  useEffect(() => {
    const selectedType = companyTypes.find(
      ({ value }) => value === companyType,
    );
    setSelectedCompanyType(selectedType.label);
  }, [companyType]);

  const commonComponents = [
    <CompanyTypeSelector
      key="companyTypeSelector"
      selectedCompanyType={selectedCompanyType}
      handlePrevStep={handlePrevStep}
    />,
    <CreditRadios key="credit" />,
    <BusinessTypeSelector
      key="businessType"
      businessTypeData={businessTypeData}
    />,
  ];

  const mainRoute = [
    commonComponents,
    <CompanyNumberSelector key="companyNumber" />,
  ];

  const soleTraderRoute = [
    <AlertBox
      key="alert"
      body="As part of our online fraud protection process we may ask you questions during this application designed to verify your identity, in order to reduce the potential for fraud to both yourself and City Electrical Factors Ltd. This service is provided by Creditsafe who is our chosen business information provider, this may leave a soft footprint on your credit file."
    />,
    commonComponents,
    <SoleTraderCompany key="soleTraderCompany" />,
  ];

  const governmentRoute = [
    <CompanyTypeSelector
      key="companyTypeSelector"
      selectedCompanyType={selectedCompanyType}
      handlePrevStep={handlePrevStep}
      className="cef-ui-inner-form-section__clear-styles"
    />,
    <GovernmentBody key="governmentLocalAuthorityCharity" />,
  ];

  const companyComponents = {
    0: mainRoute, // LC
    1: soleTraderRoute, // Sole Trader
    3: governmentRoute, // Government
    5: mainRoute, // LLP
    6: mainRoute, // PLC
  };

  return (
    <>
      <MetaHelmet />
      <StepTemplate step={1}>{companyComponents[companyType]}</StepTemplate>
    </>
  );
};

export default Step2;
